import { MdArrowForward } from "react-icons/md"
import Paragraphs from "../admission/paragraphs"
import { PropTypes } from 'prop-types';
import PopupDialog from "../news/popupDialog";
import { DecodeHtml } from "../../utils/decodeHtml";
import ShowPopUp from "./rentalFacilities/showPopUp";

const SpecialProgrammes = ({ training }) => {


    const title = training?.title2
    const description = training?.description2




    const paragraphs = [
        [
            "UNITEN offers and manages professional services to create long-term value for the University from its customers, markets, and relationships with the local and global community. The Business Development Team (BDD) act as catalyst and champion for a wide range of knowledge exchange opportunities. We pro-actively engage with external organizations to identify opportunities for new business collaborations and networks.",
        ],

        [
            "We work closely with colleges and research institutes within the University to provide support and advice on projects involving third parties and welcome opportunities to discuss project ideas and potential collaborations.",
        ],

        [
            "With its vast experience of more than 20 years and growing collection of knowledge, our team is dedicated to offer a wide-range of business and development solutions within the niche areas of power engineering, engineering design, IT solutions, professional development and leadership training series, language and communications, preparatory programme for overseas university, Board of Engineers Malaysia (BEM) top-up program, business management, occupational safety and health assessment, energy policy and workforce well-being.",
        ],

    ]
    // const programmes = [
    //     {
    //         title: "Check out our digital booklets and brochures",
    //         programmes: [
    //             {
    //                 name: "UNITEN Professional Services Booklet",
    //                 children: ""
    //             },
    //             {
    //                 name: "Upcoming Training",
    //                 children: ""
    //             }

    //         ]
    //     },
    //     {
    //         title: "EXECUTIVE EDUCATIONAL PROGRAM",
    //         programmes: [
    //             {
    //                 name: "Energy Series",
    //                 children: ""
    //             },
    //             {
    //                 name: "Management Series",
    //                 children: ""
    //             },
    //             {
    //                 name: "Information & Technology Series",
    //                 children: ""
    //             },
    //         ]
    //     },
    //     {
    //         title: "SPECIAL PROGRAM - ACADEMIC RELATED",
    //         programmes: [
    //             {
    //                 name: "BEM GAP Program",
    //                 children: ""
    //             },
    //             {
    //                 name: "MBA for Leaders",
    //                 children: ""
    //             },
    //             {
    //                 name: "Franchise",
    //                 children: ""
    //             },
    //         ]
    //     },
    //     {
    //         title: "SPECIAL PROGRAM - NON ACADEMIC RELATED",
    //         programmes: [
    //             {
    //                 name: "Professional Educational Tourism",
    //                 children: ""
    //             },
    //             {
    //                 name: "Youth Empowerment Program & School Holiday Camp",
    //                 children: ""
    //             },
    //             {
    //                 name: "Team Building",
    //                 children: ""
    //             },
    //             {
    //                 name: "Professional Executive Development Program",
    //                 children: ""
    //             },
    //         ]
    //     },
    // ]
    const programmes = training?.labelButtonSections?.items?.map((item) => {
        item = item?.content?.properties
        const title = item?.title
        const programmes = item?.buttons?.items?.map((programme) => {
            programme = programme?.content?.properties
            return {
                name: programme?.label || programme?.buttonLabel,
                link: programme?.buttonLabel  == "BEM GAP" ? "/training-services/bem-gap" : programme?.link,
                children:programme?.buttonLabel  == "BEM GAP" ? null : programme?.Header ? <PopupDialog title={programme?.Header} paragraphs={DecodeHtml({ html: programme?.description?.markup })} /> : null
            }
        })
        return {
            title,
            programmes
        }
    }
    )





    return (
        <div className="grid gap-5">
            <h1 className="text-4xl font-bold ">{title}</h1>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10  place-items-start">
                <p className="w-auto  text-justify text-sky-950  text-base font-normal leading-normal whitespace-pre-line" >{description}</p>
                {/* <Paragraphs paragraphs={paragraphs} /> */}
                <div className="grid gap-2">
                    {
                        programmes?.map((programme, index) => (
                            <div key={index} className="grid gap-2">
                                <h1 className="text-2xl font-bold ">{programme.title}</h1>
                                <div className="grid gap-2">
                                    {
                                        programme?.programmes?.map((programme, index) => (

                                            programme?.children ?
                                                <ShowPopUp key={index} title={programme?.name} >
                                                    {programme?.children}
                                                </ShowPopUp>
                                                :

                                                <a href={programme?.link} target="_blank" rel="noreferrer" key={index} className="flex items-center gap-5 text-[1rem] text-[#0039CB] font-bold">
                                                    <h2 className=" ">{programme.name}</h2>
                                                    <MdArrowForward />
                                                </a>

                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }

                </div>
            </div>
        </div>
    )
}
SpecialProgrammes.propTypes = {
    training: PropTypes.any
}
export default SpecialProgrammes